import { render, staticRenderFns } from "./RankingView.vue?vue&type=template&id=33cbac6d&scoped=true"
import script from "./RankingView.vue?vue&type=script&lang=js"
export * from "./RankingView.vue?vue&type=script&lang=js"
import style0 from "./RankingView.vue?vue&type=style&index=0&id=33cbac6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cbac6d",
  null
  
)

export default component.exports